import { EnvironmentService } from './core/services/environment/environment.service';
import { BaseHttp } from '@app/core/services/http/basic.http';
import { Injectable, Injector } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { CLIENT_IDENTIFIER_LOCAL_STORAGE_KEY, CLIENT_IDENTIFIER_PARAMETER_KEY } from "@app/shared/constants/utiliyconstants";
import { ThemeService } from "@app/core/services/themes/theme.service";
import { environment } from "../environments/environment";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  constructor(private injector: Injector, private _envSvc: EnvironmentService, private _http: BaseHttp, private themeService: ThemeService) { }

  /**
   * 1. Sets the client based on how the site was launched
   * 2. Downloads runtime configs
   */
  async initEssentials(): Promise<Subscription> {

    const location =  this.injector.get(Location);
    const url = location.path();

    try {
      // Check the incoming URL for client identifier
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });

        if (httpParams.has(CLIENT_IDENTIFIER_PARAMETER_KEY)) {
          const themeName = httpParams.get(CLIENT_IDENTIFIER_PARAMETER_KEY)?.toLowerCase() ?? "";
          sessionStorage?.setItem(CLIENT_IDENTIFIER_LOCAL_STORAGE_KEY, themeName);
          await this.themeService.setCurrentTheme(themeName);
        }
        else {
          sessionStorage?.removeItem(CLIENT_IDENTIFIER_LOCAL_STORAGE_KEY);
        }
      }
      else {
        sessionStorage?.removeItem(CLIENT_IDENTIFIER_LOCAL_STORAGE_KEY);
      }
    }
    catch (error) {
      sessionStorage?.removeItem(CLIENT_IDENTIFIER_LOCAL_STORAGE_KEY);
    }

    return this.fetchConfigs().subscribe();
  }

  private fetchConfigs(): Observable<boolean> {
    const env = environment.envName;
    const path = "/assets/appdata/appsettings";
    const uri = `${path}.${env}.json`;

    return this._http.get(uri).pipe(
      map((response: {}) => {
        if (!!response) {
          if (!this._envSvc.isProductionMode()) {
            console.log(`Settings loaded - ${JSON.stringify({ data: response}, null, 4)}`);
          }
          this._envSvc.setRuntimeConfigs(response);
        }
        return true;
      }),
      catchError(() => { return of(true) })
    );
  }
}
